import ENV from "config";
import { FormattedMessage } from "react-intl";
import "./InfoMessage.scss";

const InfoMessage = ({
  message,
  customStyle,
}: {
  message: string;
  customStyle?: string;
}) => {
  const gotoLoginPage = () => {
    return window.location.replace(`${ENV.MAIN_SITE_URL}/login`);
  };

  return (
    <span className={`info-message ${customStyle}`} onClick={gotoLoginPage}>
      <FormattedMessage id={message} />
    </span>
  );
};

export default InfoMessage;
